// import React, { useState, useEffect, useRef } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import moment from "moment";
// import Header from "../../../Common/Layout/Header";
// import config from "../../../Common/Configurations/APIConfig";
// import apiService from "../../../Common/Configurations/APIService";
// import { useAuth } from "../../../Common/Configurations/AuthContext";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import "./ExpenseView.css";

// const ExpenseView = () => {
//   const { user, loading } = useAuth();
//   const { invoiceId } = useParams();
//   const navigate = useNavigate();
//   const [invoice, setInvoice] = useState(null);
//   const [error, setError] = useState(null);
//   const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
//   const invoiceRef = useRef();

//   const GetData = async () => {
//     if (invoiceId) {
//       try {
//         const data = await apiService.getById(config.GETINVOICEBYID, invoiceId);
//         console.log("Expense Invoice Data:", data);
//         setInvoice(data);
//         setError(null);
//       } catch (err) {
//         setError("Failed to fetch expense invoice details. Please try again.");
//         console.error(err);
//       } finally {
//       }
//     }
//   };

//   useEffect(() => {
//     if (!loading && user && invoiceId) {
//       GetData();
//     }
//   }, [user, loading, invoiceId]);

//   // Debug user object
//   useEffect(() => {
//     console.log("👤 Current User Object:", user);
//     if (user) {
//       console.log("📸 User Logo Property:", user.logo);
//       console.log("🔍 All User Properties:", Object.keys(user));
//     }
//   }, [user]);

//   const downloadPDF = async () => {
//     if (!invoiceRef.current) return;

//     setIsGeneratingPDF(true);
//     try {
//       const element = invoiceRef.current;
//       const canvas = await html2canvas(element, {
//         scale: 2,
//         useCORS: true,
//         logging: false,
//         backgroundColor: "#ffffff",
//       });

//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();

//       const imgWidth = canvas.width;
//       const imgHeight = canvas.height;
//       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//       const imgX = (pdfWidth - imgWidth * ratio) / 2;
//       const imgY = 10;

//       pdf.addImage(
//         imgData,
//         "PNG",
//         imgX,
//         imgY,
//         imgWidth * ratio,
//         imgHeight * ratio
//       );

//       const fileName = `expense-invoice-${
//         invoice.invoiceNumber || invoice.invoiceId
//       }.pdf`;
//       pdf.save(fileName);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       alert("Failed to generate PDF. Please try again.");
//     } finally {
//       setIsGeneratingPDF(false);
//     }
//   };

//   const printInvoice = () => {
//     window.print();
//   };

//   if (loading) return <p>Loading...</p>;

//   if (!user) {
//     navigate("/");
//   }

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="row">
//               <div className="col-xl-12">
//                 <div className="card">
//                   <div className="card-body">
//                     {loading && (
//                       <div className="text-center p-5">
//                         <p>Loading expense invoice...</p>
//                       </div>
//                     )}
//                     {error && <div className="alert alert-danger">{error}</div>}

//                     {!loading && !error && invoice && (
//                       <div className="expenseview-invoice-wrapper">
//                         <div className="expenseview-view-actions-bar">
//                           <button
//                             onClick={() => navigate("/expenselist")}
//                             className="btn btn-secondary"
//                           >
//                             <i className="ri-arrow-left-line align-bottom me-1" />{" "}
//                             Back To List
//                           </button>
//                           <div>
//                             <button
//                               onClick={downloadPDF}
//                               disabled={isGeneratingPDF}
//                               className="btn btn-success me-2"
//                             >
//                               <i className="ri-download-line align-bottom me-1" />
//                               {isGeneratingPDF
//                                 ? "Generating PDF..."
//                                 : "Download PDF"}
//                             </button>
//                             <button
//                               onClick={printInvoice}
//                               className="btn btn-info me-2"
//                             >
//                               <i className="ri-printer-line align-bottom me-1" />
//                               Print
//                             </button>
//                             <Link
//                               to={`/editexpenseinvoice/${invoice.invoiceId}`}
//                               className="btn btn-primary"
//                             >
//                               <i className="ri-pencil-fill align-bottom me-1" />{" "}
//                               Edit Invoice
//                             </Link>
//                           </div>
//                         </div>

//                         <div
//                           ref={invoiceRef}
//                           className="expenseview-invoice-container"
//                           id="invoice-to-print"
//                         >
//                           <header className="expenseview-invoice-header">
//                             <div className="expenseview-from-details">
//                               <div className="expenseview-company-logo">
//                                 {user.logo ? (
//                                   <img
//                                     src={user.logo}
//                                     alt="Company Logo"
//                                     className="expenseview-logo-img"
//                                     onError={(e) => {
//                                       console.error(
//                                         "Logo failed to load, using static fallback"
//                                       );
//                                       e.target.style.display = "none";
//                                       // You can set a fallback image here if needed
//                                     }}
//                                   />
//                                 ) : (
//                                   <div
//                                     style={{
//                                       fontSize: "12px",
//                                       color: "#666",
//                                       padding: "10px",
//                                       background: "#f8f9fa",
//                                       borderRadius: "4px",
//                                       marginBottom: "10px",
//                                     }}
//                                   >
//                                     No company logo available in user profile
//                                   </div>
//                                 )}
//                               </div>

//                               <h3 className="expenseview-company-name">
//                                 {invoice.companyDetails?.companyName || "N/A"}
//                               </h3>
//                               <p>{invoice.companyDetails?.address || ""}</p>
//                               <p>{`${invoice.companyDetails?.city || ""}, ${
//                                 invoice.companyDetails?.state || ""
//                               }`}</p>
//                               <p>
//                                 <strong>Email:</strong>{" "}
//                                 {invoice.companyDetails?.email || "N/A"}
//                               </p>
//                               <p>
//                                 <strong>Phone:</strong>{" "}
//                                 {invoice.companyDetails?.phoneNumber || "N/A"}
//                               </p>
//                             </div>
//                             <div className="expenseview-invoice-title">
//                               <h1>EXPENSE INVOICE</h1>
//                             </div>
//                           </header>

//                           <section className="expenseview-invoice-meta-details">
//                             <div className="expenseview-to-details">
//                               <h4>BILL TO:</h4>
//                               <p>
//                                 <strong>
//                                   {invoice.supplierDetails?.supplierName ||
//                                     "N/A"}
//                                 </strong>
//                                 <p>
//                                   {" "}
//                                   {invoice.supplierDetails?.phoneNumber ||
//                                     "N/A"}
//                                 </p>
//                               </p>
//                               {invoice.supplierDetails?.gstNo && (
//                                 <p>
//                                   <strong>GST:</strong>{" "}
//                                   {invoice.supplierDetails.gstNo}
//                                 </p>
//                               )}
//                               {invoice.supplierDetails?.panNumber && (
//                                 <p>
//                                   <strong>PAN:</strong>{" "}
//                                   {invoice.supplierDetails.panNumber}
//                                 </p>
//                               )}
//                             </div>
//                             <div className="expenseview-meta-info">
//                               <p>
//                                 <strong>Invoice No:</strong>{" "}
//                                 <span>{invoice.invoiceNumber || "N/A"}</span>
//                               </p>
//                               <p>
//                                 <strong>Invoice Date:</strong>{" "}
//                                 <span>
//                                   {invoice.invoiceDate
//                                     ? moment(invoice.invoiceDate).format(
//                                         "DD-MMM-YYYY"
//                                       )
//                                     : "N/A"}
//                                 </span>
//                               </p>
//                               <p>
//                                 <strong>Due Date:</strong>{" "}
//                                 <span>
//                                   {invoice.dueDate
//                                     ? moment(invoice.dueDate).format(
//                                         "DD-MMM-YYYY"
//                                       )
//                                     : "N/A"}
//                                 </span>
//                               </p>
//                               <p>
//                                 <strong>Status:</strong>{" "}
//                                 <span
//                                   className={`expenseview-status-badge expenseview-status-${invoice.status?.toLowerCase()}`}
//                                 >
//                                   {invoice.status || "N/A"}
//                                 </span>
//                               </p>
//                               <p>
//                                 <strong>Payment Method:</strong>{" "}
//                                 <span>{invoice.transactionType || "N/A"}</span>
//                               </p>
//                             </div>
//                           </section>

//                           <section className="expenseview-invoice-items">
//                             <table className="expenseview-items-table">
//                               <thead>
//                                 <tr>
//                                   <th>S.No</th>
//                                   <th>Item Description</th>
//                                   <th className="expenseview-text-center">
//                                     Quantity
//                                   </th>
//                                   <th className="expenseview-text-right">
//                                     Unit Price
//                                   </th>
//                                   <th className="expenseview-text-right">
//                                     Amount
//                                   </th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 {invoice.items && invoice.items.length > 0 ? (
//                                   invoice.items.map((item, index) => (
//                                     <tr key={item.invoiceItemId || index}>
//                                       <td>{index + 1}</td>
//                                       <td>{item.description || "N/A"}</td>
//                                       <td className="expenseview-text-center">
//                                         {item.quantity || "0"}
//                                       </td>
//                                       <td className="expenseview-text-right">{`${
//                                         invoice.currencyCode || "USD"
//                                       } ${(item.unitPrice || 0).toFixed(
//                                         2
//                                       )}`}</td>
//                                       <td className="expenseview-text-right">{`${
//                                         invoice.currencyCode || "USD"
//                                       } ${(
//                                         (item.quantity || 0) *
//                                         (item.unitPrice || 0)
//                                       ).toFixed(2)}`}</td>
//                                     </tr>
//                                   ))
//                                 ) : (
//                                   <tr>
//                                     <td
//                                       colSpan="5"
//                                       className="expenseview-text-center"
//                                     >
//                                       No items found
//                                     </td>
//                                   </tr>
//                                 )}
//                               </tbody>
//                             </table>
//                           </section>

//                           <footer className="expenseview-invoice-footer">
//                             <div className="expenseview-notes-and-terms">
//                               {invoice.notes && (
//                                 <>
//                                   <h4>Notes</h4>
//                                   <p>{invoice.notes}</p>
//                                 </>
//                               )}
//                               {invoice.terms && (
//                                 <>
//                                   <h4>Terms & Conditions</h4>
//                                   <p>{invoice.terms}</p>
//                                 </>
//                               )}

//                               {/* Display Cheque Details if available */}
//                               {invoice.cheques &&
//                                 invoice.cheques.length > 0 && (
//                                   <>
//                                     <h4>Cheque Details</h4>
//                                     {invoice.cheques.map((cheque, index) => (
//                                       <div
//                                         key={cheque.chequeId || index}
//                                         className="expenseview-cheque-details"
//                                       >
//                                         <p>
//                                           <strong>Cheque No:</strong>{" "}
//                                           {cheque.chequeNumber || "N/A"}
//                                         </p>
//                                         <p>
//                                           <strong>Amount:</strong>{" "}
//                                           {invoice.currencyCode || "USD"}{" "}
//                                           {(cheque.amount || 0).toFixed(2)}
//                                         </p>
//                                         <p>
//                                           <strong>Issue Date:</strong>{" "}
//                                           {cheque.issueDate
//                                             ? moment(cheque.issueDate).format(
//                                                 "DD-MMM-YYYY"
//                                               )
//                                             : "N/A"}
//                                         </p>
//                                         {cheque.clearedDate && (
//                                           <p>
//                                             <strong>Cleared Date:</strong>{" "}
//                                             {moment(cheque.clearedDate).format(
//                                               "DD-MMM-YYYY"
//                                             )}
//                                           </p>
//                                         )}
//                                         <p>
//                                           <strong>Status:</strong>{" "}
//                                           {cheque.status || "N/A"}
//                                         </p>
//                                       </div>
//                                     ))}
//                                   </>
//                                 )}
//                             </div>
//                             <div className="expenseview-invoice-summary">
//                               <div className="expenseview-summary-row">
//                                 <span>Subtotal</span>
//                                 <span>{`${invoice.currencyCode || "USD"} ${(
//                                   invoice.subtotal || 0
//                                 ).toFixed(2)}`}</span>
//                               </div>
//                               {invoice.discount > 0 && (
//                                 <div className="expenseview-summary-row">
//                                   <span>Discount</span>
//                                   <span>
//                                     -{" "}
//                                     {`${invoice.currencyCode || "USD"} ${(
//                                       invoice.discount || 0
//                                     ).toFixed(2)}`}
//                                   </span>
//                                 </div>
//                               )}
//                               {invoice.tax > 0 && (
//                                 <div className="expenseview-summary-row">
//                                   <span>Tax</span>
//                                   <span>
//                                     +{" "}
//                                     {`${invoice.currencyCode || "USD"} ${(
//                                       invoice.tax || 0
//                                     ).toFixed(2)}`}
//                                   </span>
//                                 </div>
//                               )}
//                               {invoice.taxDetails &&
//                                 Object.entries(invoice.taxDetails).map(
//                                   ([taxName, taxRate]) => (
//                                     <div
//                                       className="expenseview-summary-row expenseview-tax-detail"
//                                       key={taxName}
//                                     >
//                                       <span>
//                                         {taxName} @ {taxRate}%
//                                       </span>
//                                       <span></span>
//                                     </div>
//                                   )
//                                 )}
//                               <div className="expenseview-summary-row expenseview-grand-total">
//                                 <span>Grand Total</span>
//                                 <span>{`${invoice.currencyCode || "USD"} ${(
//                                   invoice.grandTotal || 0
//                                 ).toFixed(2)}`}</span>
//                               </div>
//                             </div>
//                           </footer>

//                           {invoice.bankAccountDetails && (
//                             <section className="expenseview-bank-details-section">
//                               <h4>Bank Details</h4>
//                               <p>
//                                 <strong>Bank:</strong>{" "}
//                                 {invoice.bankAccountDetails.bankName || "N/A"}
//                               </p>
//                               <p>
//                                 <strong>Account Number:</strong>{" "}
//                                 {invoice.bankAccountDetails.accountNumber ||
//                                   "N/A"}
//                               </p>
//                               <p>
//                                 <strong>IFSC Code:</strong>{" "}
//                                 {invoice.bankAccountDetails.ifscCode || "N/A"}
//                               </p>
//                             </section>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ExpenseView;

import React, { useState, useEffect, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Header from "../../../Common/Layout/Header";

import config from "../../../Common/Configurations/APIConfig";
import apiService from "../../../Common/Configurations/APIService";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import "./ExpenseView.css";

const ExpenseView = () => {
  const { user, loading } = useAuth();
  const { invoiceId } = useParams(); 
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [error, setError] = useState(null);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const invoiceRef = useRef();

  const GetData = async () => {
    if (invoiceId) {
      try {
        const data = await apiService.getById(config.GETINVOICEBYID, invoiceId);
        setInvoice(data);
        setError(null);
      } catch (err) {
        setError("Failed to fetch expense invoice details. Please try again.");
        console.error(err);
      }
    }
  };

  useEffect(() => {
    if (!loading && user && invoiceId) {
      GetData();
    }
  }, [user, loading, invoiceId]);

  const downloadPDF = async () => {
    if (!invoiceRef.current || !invoice) return;

    setIsGeneratingPDF(true);
    try {
      const element = invoiceRef.current;
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 10;

      pdf.addImage(imgData, "PNG", imgX, imgY, imgWidth * ratio, imgHeight * ratio);

      const fileName = `expense-invoice-${invoice.invoiceNumber}.pdf`;
      pdf.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const printInvoice = () => {
    window.print();
  };

  if (loading) return <p>Loading...</p>;

  if (!user) {
    navigate("/");
    return null;
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection="accounts" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    {error && <div className="alert alert-danger">{error}</div>}

                    {!loading && !error && invoice && (
                      <div className="expenseview-invoice-wrapper">
                        <div className="expenseview-view-actions-bar">
                          <button
                            onClick={() => navigate("/expenselist")}
                            className="btn btn-secondary"
                          >
                            <i className="ri-arrow-left-line align-bottom me-1" />{" "}
                            Back To List
                          </button>
                          <div>
                            <button
                              onClick={downloadPDF}
                              disabled={isGeneratingPDF}
                              className="btn btn-success me-2"
                            >
                              <i className="ri-download-line align-bottom me-1" />
                              {isGeneratingPDF ? "Generating PDF..." : "Download PDF"}
                            </button>
                            <button onClick={printInvoice} className="btn btn-info me-2">
                              <i className="ri-printer-line align-bottom me-1" />
                              Print
                            </button>
                          </div>
                        </div>

                        <div ref={invoiceRef} className="expenseview-invoice-container" id="invoice-to-print">
                          <header className="expenseview-invoice-header">
                            <div className="expenseview-from-details">
                              <div className="expenseview-company-logo">
                                {user.logo && (
                                  <img src={user.logo} alt="Logo" className="expenseview-logo-img" />
                                )}
                              </div>
                              <h3 className="expenseview-company-name">
                                {user.companyname || user.companyName}
                              </h3>
                              <p>{user.address}</p>
                              <p>{user.city}, {user.state} - {user.zipCode}</p>
                              <p><strong>Email:</strong> {user.email}</p>
                              <p><strong>Phone:</strong> {user.phoneNumber}</p>
                            </div>
                            <div className="expenseview-invoice-title">
                              <h1>EXPENSE INVOICE</h1>
                            </div>
                          </header>

                          <section className="expenseview-invoice-meta-details">
                            <div className="expenseview-to-details">
                              <h4>PAID TO / VENDOR:</h4>
                              <p><strong>{invoice.partyName}</strong></p>
                              {invoice.partyGstin && <p>GST: {invoice.partyGstin}</p>}
                              {invoice.phoneNumber && <p>Phone: {invoice.phoneNumber}</p>}
                            </div>
                            <div className="expenseview-meta-info">
                              <p><strong>Expense No:</strong> <span>{invoice.invoiceNumber}</span></p>
                              <p><strong>Date:</strong> <span>{moment(invoice.date).format("DD-MMM-YYYY")}</span></p>
                              <p><strong>Due Date:</strong> <span>{invoice.dueDate ? moment(invoice.dueDate).format("DD-MMM-YYYY") : "N/A"}</span></p>
                              <p><strong>Status:</strong> 
                                <span className={`expenseview-status-badge expenseview-status-${invoice.status?.toLowerCase()}`}>
                                  {invoice.status}
                                </span>
                              </p>
                            </div>
                          </section>

                          <section className="expenseview-invoice-items">
                            <table className="expenseview-items-table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Expense Description</th>
                                  <th className="expenseview-text-center">Qty</th>
                                  <th className="expenseview-text-right">Unit Price</th>
                                  <th className="expenseview-text-right">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {invoice.items && invoice.items.length > 0 ? (
                                  invoice.items.map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item.description}</td>
                                      <td className="expenseview-text-center">{item.quantity}</td>
                                      <td className="expenseview-text-right">
                                        {`${invoice.currencyCode} ${Number(item.rate || 0).toFixed(2)}`}
                                      </td>
                                      <td className="expenseview-text-right">
                                        {`${invoice.currencyCode} ${(
                                          Number(item.quantity || 0) * Number(item.rate || 0)
                                        ).toFixed(2)}`}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td>1</td>
                                    <td>General Expense / Category: {invoice.transactionType}</td>
                                    <td className="expenseview-text-center">1</td>
                                    <td className="expenseview-text-right">
                                      {`${invoice.currencyCode} ${Number(invoice.baseAmount || 0).toFixed(2)}`}
                                    </td>
                                    <td className="expenseview-text-right">
                                      {`${invoice.currencyCode} ${Number(invoice.baseAmount || 0).toFixed(2)}`}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </section>

                          <footer className="expenseview-invoice-footer">
                            <div className="expenseview-notes-and-terms">
                              {invoice.notes && (<div><h4>Notes</h4><p>{invoice.notes}</p></div>)}
                              {invoice.terms && (<div><h4>Terms</h4><p>{invoice.terms}</p></div>)}
                            </div>
                            <div className="expenseview-invoice-summary">
                              <div className="expenseview-summary-row">
                                <span>Subtotal</span>
                                <span>{invoice.currencyCode} {Number(invoice.baseAmount).toFixed(2)}</span>
                              </div>
                              <div className="expenseview-summary-row">
                                <span>Discount</span>
                                <span>-{invoice.currencyCode} {Number(invoice.discount).toFixed(2)}</span>
                              </div>
                              
                              {invoice.taxDetails && (
                                <>
                                   {invoice.taxDetails.cgstAmount > 0 && (
                                     <div className="expenseview-summary-row expenseview-tax-detail">
                                        <span>CGST</span>
                                        <span>+{invoice.currencyCode} {Number(invoice.taxDetails.cgstAmount).toFixed(2)}</span>
                                     </div>
                                   )}
                                   {invoice.taxDetails.sgstAmount > 0 && (
                                     <div className="expenseview-summary-row expenseview-tax-detail">
                                        <span>SGST</span>
                                        <span>+{invoice.currencyCode} {Number(invoice.taxDetails.sgstAmount).toFixed(2)}</span>
                                     </div>
                                   )}
                                   {invoice.taxDetails.igstAmount > 0 && (
                                     <div className="expenseview-summary-row expenseview-tax-detail">
                                        <span>IGST</span>
                                        <span>+{invoice.currencyCode} {Number(invoice.taxDetails.igstAmount).toFixed(2)}</span>
                                     </div>
                                   )}
                                   <div className="expenseview-summary-row">
                                      <span>Total Tax</span>
                                      <span>+{invoice.currencyCode} {Number(invoice.taxDetails.totalTax).toFixed(2)}</span>
                                   </div>
                                </>
                              )}

                              <div className="expenseview-summary-row expenseview-grand-total">
                                <span>Grand Total</span>
                                <span>{invoice.currencyCode} {Number(invoice.grandTotal).toFixed(2)}</span>
                              </div>
                            </div>
                          </footer>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseView;